import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import PageHero from '@/components/feature/PageHero';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';

const FORM_URL = 'https://readdy.ai/api/form/dafo043ep053ijub1stg';

const cooperationTypes = [
  { icon: 'ri-funds-line', title: '投资合作', desc: '战略投资、财务投资与产业基金，共同参与九畴云市规模化建设。' },
  { icon: 'ri-hand-heart-line', title: '产业合作', desc: '供应链、渠道、品牌与技术服务方，加入乡村数字商业生态共建。' },
  { icon: 'ri-community-line', title: '县域合作', desc: '与县域政府及商业主体合作，落地数字商业基础设施与云铺网络。' },
  { icon: 'ri-scales-3-line', title: '政策对接', desc: '对接人工智能应用服务商、服务团与相关政策申报方向。' },
  { icon: 'ri-cpu-line', title: '产品及技术合作', desc: 'AI 应用、数字商业、IoT 连接与系统集成方向的合作。' },
  { icon: 'ri-chat-3-line', title: '其他合作', desc: '其他形式的合作需求，欢迎与我们联系沟通。' },
];

export default function ContactBusiness() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="联系我们 | 与我们共建乡村数字商业"
        description="承接投资、产业、县域、政策和项目合作需求。欢迎与我们联系，共建乡村数字商业。"
        keywords="联系我们,业务联系,投资合作,产业合作,县域合作,政策对接"
        path="/contact/business"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'ContactPage',
          name: '业务联系',
          description: '承接投资、产业、县域、政策和项目合作需求',
        }}
      />
      <PageHero
        eyebrow="联系我们 · 业务联系"
        title="与我们共建"
        titleHighlight="乡村数字商业"
        subtitle="承接投资、产业、县域、政策和项目合作需求。"
        desc="欢迎投资人、产业合作伙伴、县域商业从业者与政策相关部门与我们联系，共同参与乡村数字商业建设。"
        imageUrl="https://readdy.ai/api/search-image?query=Abstract%20collaboration%20scene%20with%20two%20hands%20shaking%20over%20a%20digital%20rural%20commerce%20network%2C%20connected%20nodes%20representing%20government%20industry%20operators%20and%20consumers%2C%20deep%20graphite%20background%20with%20green%20and%20gold%20accent%20glows%2C%20clean%20minimal%20composition%2C%20cinematic%20lighting&width=1600&height=900&seq=contact-hero-01&orientation=landscape"
        imageAlt="与我们共建乡村数字商业"
      />
      <Breadcrumb items={[{ label: '联系我们' }, { label: '业务联系' }]} />

      <main>
        {/* 合作方向 */}
        <section className="w-full px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-7xl mx-auto">
            <SectionHeading
              eyebrow="合作方向"
              title="六类合作方向"
              subtitle="无论是投资、产业、县域还是政策与技术合作，我们都期待与您共建。"
            />
            <Reveal className="mt-10">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {cooperationTypes.map((c) => (
                  <div key={c.title} className="p-5 rounded-lg bg-background-100 border border-background-200">
                    <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-600">
                      <i className={`${c.icon} text-xl`}></i>
                    </div>
                    <div className="mt-3 font-heading font-bold text-foreground-950">{c.title}</div>
                    <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </section>

        {/* 联系信息 + 表单 */}
        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10">
            <div>
              <h4 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
                与我们联系
              </h4>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                请填写右侧表单，说明您的合作需求。我们将在 1—3 个工作日内与您联系。
              </p>
              <div className="mt-6 space-y-4 text-sm text-foreground-700">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-100 text-primary-600">
                    <i className="ri-mail-line"></i>
                  </div>
                  <span>huahuitechnology@hhsztech.cn</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className="ri-map-pin-2-line"></i>
                  </div>
                  <span>深圳市宝安区西乡街道蚝业社区金港大厦金港中心A座603（前海合作区）</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className="ri-time-line"></i>
                  </div>
                  <span>预计回复时间：1—3 个工作日</span>
                </div>
              </div>
            </div>

            <ContactForm />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    const hp = String(fd.get('phone_alt') || '').trim();
    if (hp) {
      setStatus('success');
      form.reset();
      return;
    }

    setStatus('loading');
    setErrorMsg('');

    const params = new URLSearchParams();
    fd.forEach((value, key) => {
      if (typeof value === 'string' && key !== 'phone_alt') {
        params.append(key, value);
      }
    });

    try {
      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
        setErrorMsg(serverMsg || '提交失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络异常，请稍后重试');
    }
  };

  return (
    <form
      id="business-contact-form"
      data-readdy-form
      onSubmit={handleSubmit}
      className="p-6 rounded-lg bg-background-50 border border-background-200 space-y-4"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs text-foreground-500 mb-1.5">姓名</label>
          <input
            name="name"
            type="text"
            required
            className="w-full px-3 py-2.5 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
            placeholder="您的姓名"
          />
        </div>
        <div>
          <label className="block text-xs text-foreground-500 mb-1.5">公司或机构</label>
          <input
            name="company"
            type="text"
            className="w-full px-3 py-2.5 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
            placeholder="您的公司或机构（选填）"
          />
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs text-foreground-500 mb-1.5">邮箱</label>
          <input
            name="email"
            type="email"
            required
            className="w-full px-3 py-2.5 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
            placeholder="you@example.com"
          />
        </div>
        <div>
          <label className="block text-xs text-foreground-500 mb-1.5">联系方式</label>
          <input
            name="phone"
            type="text"
            className="w-full px-3 py-2.5 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
            placeholder="电话或微信（选填）"
          />
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs text-foreground-500 mb-1.5">合作类型</label>
          <select
            name="cooperation_type"
            className="w-full px-3 py-2.5 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 focus:outline-none focus:border-primary-400"
          >
            <option value="投资合作">投资合作</option>
            <option value="产业合作">产业合作</option>
            <option value="县域合作">县域合作</option>
            <option value="政策对接">政策对接</option>
            <option value="产品及技术合作">产品及技术合作</option>
            <option value="其他合作">其他合作</option>
          </select>
        </div>
        <div>
          <label className="block text-xs text-foreground-500 mb-1.5">所在地区</label>
          <input
            name="region"
            type="text"
            className="w-full px-3 py-2.5 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
            placeholder="城市或地区"
          />
        </div>
      </div>
      <div>
        <label className="block text-xs text-foreground-500 mb-1.5">留言内容</label>
        <textarea
          name="message"
          rows={5}
          maxLength={500}
          className="w-full px-3 py-2.5 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 resize-none"
          placeholder="请简要说明您的合作需求（500 字以内）"
        />
      </div>

      <label className="flex items-start gap-2 text-xs text-foreground-500 cursor-pointer">
        <input type="checkbox" name="privacy" required className="mt-0.5" />
        <span>我已阅读并同意隐私声明，授权华辉数智技术在合理范围内使用我提供的信息进行业务联系。</span>
      </label>

      {/* 反垃圾蜜罐字段 */}
      <input
        type="text"
        name="phone_alt"
        className="form-hp-guard"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />

      <button
        type="submit"
        disabled={status === 'loading'}
        className="w-full px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600 disabled:opacity-60"
      >
        {status === 'loading' ? '提交中...' : '提交联系信息'}
      </button>

      {status === 'success' && (
        <p className="text-sm text-accent-600">
          提交成功，工作人员将在 1—3 个工作日内与您联系。
        </p>
      )}
      {status === 'error' && <p className="text-sm text-red-500">{errorMsg}</p>}
    </form>
  );
}